import { render, staticRenderFns } from "./FriendGroupQuickSelect.vue?vue&type=template&id=88a61036&scoped=true"
import script from "./FriendGroupQuickSelect.vue?vue&type=script&lang=js"
export * from "./FriendGroupQuickSelect.vue?vue&type=script&lang=js"
import style0 from "./FriendGroupQuickSelect.vue?vue&type=style&index=0&id=88a61036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a61036",
  null
  
)

export default component.exports